import React, { Component } from 'react'

import { Header, Divider, Grid } from 'semantic-ui-react'
import AdminLayout from '../components/AdminLayout'
import EditBaseUserForm from '../components/EditBaseUserForm'
import EditShipAddresses from '../components/EditShipAddresses'
import UserRequesterTable from '../components/UserRequesterTable'

// redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  adminClearUser,
  adminGetSingleUser,
  adminGetApprovers,
  adminEditUserProp,
  adminEditUser,
  adminCreateUserAddress,
  adminDeleteUserAddress,
  adminEditUserAddress,
  adminChangePassword
} from '../actions/admin'

class EditUserPage extends Component {
  componentWillMount() {
    const { id } = this.props.match.params
    this.props.adminGetSingleUser({ id })
    this.props.adminGetApprovers()
  }
  shouldComponentUpdate(nextProps) {
    const oldId = this.props.match.params.id
    const newId = nextProps.match.params.id
    const callUpdate = oldId !== newId
    if (callUpdate) {
      this.props.adminClearUser()
      this.props.adminGetSingleUser({ id: newId })
    }
    return true
  }
  componentWillUnmount() {
    this.props.adminClearUser()
  }
  handleChange(e, data) {
      if (data.name === 'enabled') {
      data.value = data.checked
    }
    this.props.adminEditUserProp(data.name, data.value)
  }

  handleSaveBaseUser(e) {
    e.preventDefault()
    const {
      id,
      firstname,
      lastname,
      email,
      enabled,
      role,
      approverId
    } = this.props.admin.singleUser
    this.props.adminEditUser({
      id,
      firstname,
      lastname,
      enabled,
      email,
      role,
      approverId
    })
  }

  handlePasswordReset() {
    const { id, newPassword } = this.props.admin.singleUser
    this.props.adminChangePassword({
      id,
      password: newPassword
    })
    this.props.adminEditUserProp('newPassword', '')
  }

  render() {
    const { singleUser, isUsersLoading, approvers } = this.props.admin
    const {
      id,
      username,
      enabled,
      firstname,
      lastname,
      email,
      role,
      approverId,
      newPassword,
      shipAddresses,
      isEdited,
      requesters,
      newPasswordStatus
    } = singleUser
    return (
      <AdminLayout isLoading={isUsersLoading}>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Header as="h3">Edit User</Header>
              <Divider />
              <EditBaseUserForm
                onSubmit={this.handleSaveBaseUser.bind(this)}
                enabled={enabled}
                isEdited={isEdited}
                isEditMode={true}
                username={username}
                email={email}
                firstname={firstname}
                lastname={lastname}
                role={role}
                newPassword={newPassword}
                newPasswordStatus={newPasswordStatus}
                approverId={approverId}
                approvers={approvers.filter(({ id: uid }) => uid !== id)}
                handleChange={this.handleChange.bind(this)}
                handlePasswordReset={this.handlePasswordReset.bind(this)}
              />
              <Divider />
              {shipAddresses && role !== 'admin' && role !== 'approver'
                ? <EditShipAddresses
                    userId={id}
                    shipAddresses={shipAddresses}
                    adminCreateUserAddress={this.props.adminCreateUserAddress}
                    adminDeleteUserAddress={this.props.adminDeleteUserAddress}
                    adminEditUserAddress={this.props.adminEditUserAddress}
                  />
                : <UserRequesterTable requesters={requesters} />}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AdminLayout>
    )
  }
}

const mapStateToProps = state => {
  return state
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      adminClearUser,
      adminGetSingleUser,
      adminGetApprovers,
      adminEditUserProp,
      adminEditUser,
      adminCreateUserAddress,
      adminDeleteUserAddress,
      adminEditUserAddress,
      adminChangePassword
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(EditUserPage)



// WEBPACK FOOTER //
// ./src/pages/EditUser.jsx